import { getDarkenColor, getLightenColor } from ".";

export default (type, colors) => {
  const styles = {
    default: {
      'editable-item': {
        customCSS: `
          .editable-item .button.editable-item__btn--alert {
            box-shadow:  1px 1px 0 0 ${getDarkenColor(colors.info_dark, 0.05)};
          }
          .editable-item__image-alignment-title,
          .editable-item__image-alignment-option .button__text {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          .editable-item__image-alignment-option.state-selected {
            border-color: ${getLightenColor(colors.primary, 2)}!important;
          }
        `
      },
      'editable-item__actions__button': {
        customCSS: `
          .editable-item__actions .button {
            color: ${colors.primary};
          }
          .editable-item__actions .button {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }
          
          .editable-item__actions .button:hover, 
          .editable-item__actions .button:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.offgray_mid, 0.05)};
          }

          .editable-item__actions .button.editable-item__btn--alert {
            color: ${colors.light};
          }
        `
      }
    },
    type1: {
      'editable-item': {
        customCSS: `
          .editable-item .button.editable-item__btn--alert {
            box-shadow:  1px 1px 0 0 ${getDarkenColor(colors.info_dark, 0.05)};
          }
          .editable-item__image-alignment-title,
          .editable-item__image-alignment-option .button__text {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          .editable-item__image-alignment-option.state-selected {
            border-color: ${getLightenColor(colors.primary, 2)}!important;
          }
        `
      },
      'editable-item__actions__button': {
        customCSS: `
          .editable-item__actions .button {
            color: ${colors.primary};
          }
          .editable-item__actions .button {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }
          
          .editable-item__actions .button:hover, 
          .editable-item__actions .button:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.offgray_mid, 0.05)};
          }

          .editable-item__actions .button.editable-item__btn--alert {
            color: ${colors.light};
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/create.js